import React from 'react';
import { Package, DollarSign, CheckCircle } from 'react-feather';

export interface ServicePackageData {
  id: number;
  name: string;
  description: string;
  price: number;
}

interface ServicePackageCardProps {
  packages: ServicePackageData[];
  onSelect: (pkg: ServicePackageData) => void;
  disabled?: boolean;
}

const ServicePackageCard: React.FC<ServicePackageCardProps> = ({
  packages,
  onSelect,
  disabled = false,
}) => {
  if (packages.length === 0) return null;

  return (
    <div className="service-request-card service-request-card--packages">
      <div className="service-request-card__header">
        <div className="service-request-card__icon service-request-card__icon--package">
          <Package size={20} />
        </div>
        <h3 className="service-request-card__title">Select Service Package</h3>
      </div>

      <div className="service-request-card__content">
        <p className="service-request-card__description">
          Choose from our available service packages for your equipment:
        </p>

        <div className="service-request-packages">
          {packages.map((pkg) => (
            <div key={pkg.id} className="service-request-package">
              <div className="service-request-package__header">
                <div className="service-request-package__name">{pkg.name}</div>
                <div className="service-request-package__price">
                  <DollarSign size={16} />
                  {Number(pkg.price).toFixed(2)}
                </div>
              </div>

              <div className="service-request-package__description">
                {pkg.description}
              </div>

              <button
                className="service-request-package__btn"
                onClick={() => onSelect(pkg)}
                disabled={disabled}
                type="button"
              >
                <CheckCircle size={16} />
                Select This Package
              </button>
            </div>
          ))}
        </div>

        <div className="service-request-card__hint">
          <span>Need something different? Describe it in the chat.</span>
        </div>
      </div>
    </div>
  );
};

export default ServicePackageCard;
